module.exports = __webpack_public_path__ + "img/top_banner01.f495ccaf.png";